import { lazy } from 'react';
import { HiOutlineMapPin, HiOutlineDocumentCheck, HiOutlineChartBar } from 'react-icons/hi2';
import type { ModuleManifest } from '../types';

const SpatialLayout = lazy(() => import('./components/SpatialLayout'));
const ZonePlanPage = lazy(() => import('./components/ZonePlanPage'));
const PermitListPage = lazy(() => import('./components/PermitListPage'));
const PermitDetailPage = lazy(() => import('./components/PermitDetailPage'));
const CapacityDashboard = lazy(() => import('./components/CapacityDashboard'));

export const spatialManifest: ModuleManifest = {
  name: 'spatial',
  featureFlag: 'module_spatial',
  label: 'Spatial Planning',
  icon: HiOutlineMapPin,
  basePath: 'spatial',
  navItems: [
    { key: 'sp-zones', label: 'Zone Plans', icon: HiOutlineMapPin, path: '/app/spatial/zones', matchFn: (p) => p.startsWith('/app/spatial/zones') },
    { key: 'sp-permits', label: 'Permits', icon: HiOutlineDocumentCheck, path: '/app/spatial/permits', matchFn: (p) => p.startsWith('/app/spatial/permits') },
    { key: 'sp-capacity', label: 'Capacity', icon: HiOutlineChartBar, path: '/app/spatial/capacity', matchFn: (p) => p.startsWith('/app/spatial/capacity') },
  ],
  routes: [
    {
      path: 'spatial',
      component: SpatialLayout,
      children: [
        { path: 'zones', component: ZonePlanPage },
        { path: 'permits', component: PermitListPage },
        { path: 'permits/:permitId', component: PermitDetailPage },
        { path: 'capacity', component: CapacityDashboard },
      ],
    },
  ],
};
